import { FaPodcast } from "react-icons/fa";

interface PodcastCitationsProps {
  citation: string[] | any;
  onCitationClick?: (citation: string) => void;
  iconTitle?: string;
}

function PodcastCitations({ citation, onCitationClick, iconTitle }: PodcastCitationsProps) {
  //   console.log("citation in podcast: ", citation);
  function onCitationClicked(citations: any): void {
    if (onCitationClick) {
      onCitationClick(citations);
    }
  }


  return (
    <div>
      <button
        onClick={e => {
          e.preventDefault();
          onCitationClicked(citation);
        }}
        className="cursor-pointer text-left block whitespace-normal link_text_color hover:underline"
      >
        {citation.title}&nbsp;
        {/* <span>{getStartTimeInMinutesSeconds(citation.link)}</span> */}
        &nbsp;
        <FaPodcast className="inline" title={iconTitle} />
      </button>
    </div>
  );
}

export default PodcastCitations;
